import { render, staticRenderFns } from "./front-stockorder.vue?vue&type=template&id=751dd57f"
import script from "./front-stockorder.vue?vue&type=script&lang=ts"
export * from "./front-stockorder.vue?vue&type=script&lang=ts"
import style0 from "./front-stockorder.vue?vue&type=style&index=0&id=751dd57f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports